import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { TeacherEvaluationCriteriaType } from '../../../types/TeacherEvaluation';

const initialState:TeacherEvaluationCriteriaType = {
    idAcademicYear: '',
    description: '',
    isForStudent: false,
    status: false
}

const teacherEvaluationCriteriaSlice = createSlice({
  name: "teacherEvaluationCriteriaForm",
  initialState,
  reducers: {
    setTeacherEvaluationCriteriaData:(state, action:PayloadAction<TeacherEvaluationCriteriaType>)=>({...state, ...action.payload}), 
    resetTeacherEvaluationCriteriaData :()=>({...initialState})
  }
});

export const {setTeacherEvaluationCriteriaData,resetTeacherEvaluationCriteriaData } = teacherEvaluationCriteriaSlice.actions

export default teacherEvaluationCriteriaSlice.reducer